import { DocumentationLinkPreview } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTODocumentationLinkPreviewResponse = z.object({
  linkPreview: DocumentationLinkPreview,
});

export type DTODocumentationLinkPreviewResponse = z.infer<typeof DTODocumentationLinkPreviewResponse>;

//
// Write
//

export const DTODocumentationLinkPreviewRequest = z.object({
  url: z.string().optional(),
  documentationItemPersistentId: z.string().optional(),
});

export type DTODocumentationLinkPreviewRequest = z.infer<typeof DTODocumentationLinkPreviewRequest>;
